// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enterprise revamp — AI Scenario / Test Case generator pages */

.ai-testcase-generator-overlay.rt-scenario-page,
.rt-jira-host .ai-testcase-generator-overlay {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  z-index: auto !important;
  display: block !important;
  align-items: stretch !important;
  justify-content: flex-start !important;
  width: 100%;
  min-height: 0;
  animation: none !important;
  background: transparent !important;
}

.ai-testcase-generator-container.rt-scenario-panel,
.rt-jira-host .ai-testcase-generator-container {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  margin: 0 !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 0;
  border: 1px solid var(--border);
  animation: none !important;
  overflow: hidden;
}

/* Chrome header */
.rt-scenario-chrome {
  padding: 16px 20px 14px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.rt-scenario-chrome__nav {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.rt-scenario-chrome__crumb {
  font-size: 12px;
  color: var(--text-secondary);
}

.rt-scenario-chrome__title-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.rt-scenario-chrome__badges {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.rt-scenario-chrome__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.35;
}

.rt-scenario-chrome__meta {
  margin: 6px 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.rt-scenario-chrome__desc {
  margin: 12px 0 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.5;
  max-width: 72ch;
  white-space: pre-wrap;
}

.rt-scenario-toolbar {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 10px;
  padding: 12px 14px !important;
  margin-bottom: 12px;
}

.rt-scenario-toolbar .test-cases-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.rt-scenario-toolbar h3 {
  margin: 0;
  color: var(--text-primary) !important;
  font-size: 1rem !important;
}

.rt-scenario-empty {
  background: var(--surface) !important;
  border: 1px dashed var(--border) !important;
  border-radius: 10px;
  color: var(--text-secondary) !important;
  padding: 32px !important;
  text-align: center;
}

/* Content region */
.rt-scenario-page .generator-content,
.rt-jira-host .generator-content {
  padding: 16px 20px 24px !important;
  background: var(--bg-primary) !important;
  overflow: visible !important;
  flex: 1 1;
}

.rt-scenario-page .item-details,
.rt-jira-host .item-details {
  display: none; /* replaced by rt-scenario-chrome */
}

/* Scenario cards */
.rt-scenario-page .test-case-card,
.rt-jira-host .test-case-card {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 10px !important;
  color: var(--text-primary) !important;
  box-shadow: none !important;
}

.rt-scenario-page .test-case-header,
.rt-jira-host .test-case-header {
  background: transparent !important;
  border-bottom-color: var(--border) !important;
}

.rt-scenario-page .test-case-title,
.rt-jira-host .test-case-title,
.rt-scenario-page .test-case-description,
.rt-jira-host .test-case-description,
.rt-scenario-page .test-case-section h4,
.rt-jira-host .test-case-section h4,
.rt-scenario-page .expected-result,
.rt-jira-host .expected-result {
  color: var(--text-primary) !important;
  text-align: left !important;
}

.rt-scenario-page .bdd-steps,
.rt-jira-host .bdd-steps {
  gap: 6px !important;
  margin-top: 8px !important;
}

.rt-scenario-page .bdd-step,
.rt-jira-host .bdd-step {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  color: var(--text-primary) !important;
  text-align: left !important;
  padding: 8px 10px !important;
  border-radius: 6px;
}

.rt-scenario-page .bdd-step.given,
.rt-jira-host .bdd-step.given {
  border-left: 3px solid #3b82f6 !important;
}

.rt-scenario-page .bdd-step.when,
.rt-jira-host .bdd-step.when {
  border-left: 3px solid #f59e0b !important;
}

.rt-scenario-page .bdd-step.then,
.rt-jira-host .bdd-step.then {
  border-left: 3px solid #22c55e !important;
}

.rt-scenario-page .analysis-results,
.rt-jira-host .analysis-results,
.rt-scenario-page .test-cases-container,
.rt-jira-host .test-cases-container {
  background: transparent !important;
  box-shadow: none !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .analysis-results,
.rt-jira-host .analysis-results {
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: 10px;
}

.rt-scenario-page .parameter-group,
.rt-jira-host .parameter-group,
.rt-scenario-page .parameterized-suggestions,
.rt-jira-host .parameterized-suggestions {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .parameter-values .parameter-value,
.rt-jira-host .parameter-values .parameter-value,
.rt-scenario-page .parameter-chip,
.rt-jira-host .parameter-chip {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .select-all-container label,
.rt-jira-host .select-all-container label,
.rt-scenario-page .short-description,
.rt-jira-host .short-description,
.rt-scenario-page .preconditions-list,
.rt-jira-host .preconditions-list {
  color: var(--text-secondary) !important;
}

.rt-scenario-page .edit-title-input,
.rt-scenario-page .edit-description-textarea,
.rt-scenario-page .edit-expected-result-textarea,
.rt-scenario-page .edit-precondition-textarea,
.rt-scenario-page .step-text-textarea,
.rt-scenario-page .parameter-name-input,
.rt-scenario-page .parameter-value-input,
.rt-jira-host .edit-title-input,
.rt-jira-host .edit-description-textarea,
.rt-jira-host .edit-expected-result-textarea,
.rt-jira-host .edit-precondition-textarea,
.rt-jira-host .step-text-textarea,
.rt-jira-host .parameter-name-input,
.rt-jira-host .parameter-value-input {
  width: 100% !important;
  max-width: 100% !important;
  background: var(--input-background, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--input-border, var(--border)) !important;
}

.rt-scenario-page .test-case-card.editing-mode,
.rt-jira-host .test-case-card.editing-mode {
  background: var(--surface) !important;
  border-color: var(--primary, #3b82f6) !important;
}

/* Legacy buttons → token surfaces when not using rt-btn */
.rt-scenario-page .regenerate-btn,
.rt-scenario-page .view-tests-btn,
.rt-scenario-page .generate-tests-btn,
.rt-jira-host .regenerate-btn,
.rt-jira-host .view-tests-btn,
.rt-jira-host .generate-tests-btn {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
}

.rt-scenario-page .generate-tests-btn,
.rt-jira-host .generate-tests-btn {
  background: var(--primary, #2563eb) !important;
  color: #fff !important;
  border-color: transparent !important;
}

/* Jira host itself when showing list */
.rt-jira-host.jira-items-overlay {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  z-index: auto !important;
  background: var(--bg-primary) !important;
  min-height: 0;
  flex: 1 1;
}

.rt-jira-host .jira-items-container {
  background: var(--bg-primary) !important;
}

.rt-jira-host .jira-items-content,
.rt-jira-host .jira-items-tabs {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.rt-jira-host table,
.rt-jira-host th,
.rt-jira-host td {
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
  background: transparent !important;
}

.rt-jira-host th {
  background: var(--table-header, var(--bg-tertiary)) !important;
  color: var(--text-secondary) !important;
}

.rt-jira-host .back-btn {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px;
  padding: 6px 12px;
}

/* ─── Dark/light token enforcement + kill text-level boxes ─── */
.rt-scenario-page,
.rt-scenario-page .ai-testcase-generator-container,
.rt-scenario-page .rt-scenario-panel,
.rt-scenario-page .generator-content,
.rt-scenario-page .rt-scenario-chrome,
.rt-jira-host .ai-testcase-generator-container,
.rt-jira-host .generator-content {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .rt-scenario-chrome,
.rt-jira-host .rt-scenario-chrome,
.rt-scenario-page .rt-scenario-toolbar,
.rt-jira-host .rt-scenario-toolbar,
.rt-scenario-page .test-cases-header,
.rt-jira-host .test-cases-header {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.rt-scenario-page .test-case-card,
.rt-jira-host .test-case-card,
.rt-scenario-page .test-plan-card,
.rt-jira-host .test-plan-card,
.rt-scenario-page .test-suite-card,
.rt-jira-host .test-suite-card,
.rt-scenario-page .test-case-editor,
.rt-jira-host .test-case-editor,
.rt-scenario-page .analysis-results,
.rt-jira-host .analysis-results,
.rt-scenario-page .editable-parameter-group,
.rt-jira-host .editable-parameter-group {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
  box-shadow: none !important;
}

.rt-scenario-page .expected-result,
.rt-jira-host .expected-result,
.rt-scenario-page .bdd-step,
.rt-jira-host .bdd-step,
.rt-scenario-page .item-details,
.rt-jira-host .item-details,
.rt-scenario-page .collapsed-summary,
.rt-jira-host .collapsed-summary {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  color: var(--text-primary) !important;
}

/* Section titles must sit flat on the card — no boxed labels */
.rt-scenario-page .test-case-section > h4,
.rt-jira-host .test-case-section > h4,
.rt-scenario-page .test-case-section h4,
.rt-jira-host .test-case-section h4,
.rt-scenario-page .test-strategy-section h4,
.rt-jira-host .test-strategy-section h4,
.rt-scenario-page .test-suites-section h4,
.rt-jira-host .test-suites-section h4,
.rt-scenario-page h3,
.rt-jira-host h3,
.rt-scenario-page .test-cases-title h3,
.rt-jira-host .test-cases-title h3 {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  text-shadow: none !important;
  outline: none !important;
  color: var(--text-primary) !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.rt-scenario-page .test-case-section p,
.rt-jira-host .test-case-section p,
.rt-scenario-page .test-case-section li,
.rt-jira-host .test-case-section li,
.rt-scenario-page .preconditions-list li,
.rt-jira-host .preconditions-list li,
.rt-scenario-page .short-description,
.rt-jira-host .short-description,
.rt-scenario-page .test-case-description,
.rt-jira-host .test-case-description {
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
  color: var(--text-secondary) !important;
}

.rt-scenario-page .generator-header,
.rt-jira-host .generator-header {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-scenario.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;EAEE,wCAAwC;EACxC,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;EAC5B,SAAO;AACT;;AAEA;;EAEE,aAAa,EAAE,mCAAmC;AACpD;;AAEA,mBAAmB;AACnB;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;;;;;;;EAQE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,+DAA+D;EAC/D,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;;;EAIE,kCAAkC;EAClC,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;EAIE,+DAA+D;EAC/D,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;;;EAIE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;;;;;EAME,uCAAuC;AACzC;;AAEA;;;;;;;;;;;;;;EAcE,sBAAsB;EACtB,0BAA0B;EAC1B,8DAA8D;EAC9D,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;;EAEE,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA,0DAA0D;AAC1D;;;;;;EAME,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;EAEE,8CAA8C;EAC9C,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,aAAa;EACb,SAAO;AACT;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;EACrC,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,8DAA8D;EAC9D,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;;;;;;;EAOE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;;;;;EAME,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;EAYE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,+DAA+D;EAC/D,qCAAqC;AACvC;;AAEA,+DAA+D;AAC/D;;;;;;;;;;;;EAYE,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;;;;;;;EAUE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC","sourcesContent":["/* Enterprise revamp — AI Scenario / Test Case generator pages */\n\n.ai-testcase-generator-overlay.rt-scenario-page,\n.rt-jira-host .ai-testcase-generator-overlay {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  z-index: auto !important;\n  display: block !important;\n  align-items: stretch !important;\n  justify-content: flex-start !important;\n  width: 100%;\n  min-height: 0;\n  animation: none !important;\n  background: transparent !important;\n}\n\n.ai-testcase-generator-container.rt-scenario-panel,\n.rt-jira-host .ai-testcase-generator-container {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  margin: 0 !important;\n  border-radius: 12px !important;\n  box-shadow: none !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  height: auto !important;\n  min-height: 0;\n  border: 1px solid var(--border);\n  animation: none !important;\n  overflow: hidden;\n}\n\n/* Chrome header */\n.rt-scenario-chrome {\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.rt-scenario-chrome__nav {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.rt-scenario-chrome__crumb {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.rt-scenario-chrome__title-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.rt-scenario-chrome__badges {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.rt-scenario-chrome__title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.35;\n}\n\n.rt-scenario-chrome__meta {\n  margin: 6px 0 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.rt-scenario-chrome__desc {\n  margin: 12px 0 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  max-width: 72ch;\n  white-space: pre-wrap;\n}\n\n.rt-scenario-toolbar {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 10px;\n  padding: 12px 14px !important;\n  margin-bottom: 12px;\n}\n\n.rt-scenario-toolbar .test-cases-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.rt-scenario-toolbar h3 {\n  margin: 0;\n  color: var(--text-primary) !important;\n  font-size: 1rem !important;\n}\n\n.rt-scenario-empty {\n  background: var(--surface) !important;\n  border: 1px dashed var(--border) !important;\n  border-radius: 10px;\n  color: var(--text-secondary) !important;\n  padding: 32px !important;\n  text-align: center;\n}\n\n/* Content region */\n.rt-scenario-page .generator-content,\n.rt-jira-host .generator-content {\n  padding: 16px 20px 24px !important;\n  background: var(--bg-primary) !important;\n  overflow: visible !important;\n  flex: 1;\n}\n\n.rt-scenario-page .item-details,\n.rt-jira-host .item-details {\n  display: none; /* replaced by rt-scenario-chrome */\n}\n\n/* Scenario cards */\n.rt-scenario-page .test-case-card,\n.rt-jira-host .test-case-card {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 10px !important;\n  color: var(--text-primary) !important;\n  box-shadow: none !important;\n}\n\n.rt-scenario-page .test-case-header,\n.rt-jira-host .test-case-header {\n  background: transparent !important;\n  border-bottom-color: var(--border) !important;\n}\n\n.rt-scenario-page .test-case-title,\n.rt-jira-host .test-case-title,\n.rt-scenario-page .test-case-description,\n.rt-jira-host .test-case-description,\n.rt-scenario-page .test-case-section h4,\n.rt-jira-host .test-case-section h4,\n.rt-scenario-page .expected-result,\n.rt-jira-host .expected-result {\n  color: var(--text-primary) !important;\n  text-align: left !important;\n}\n\n.rt-scenario-page .bdd-steps,\n.rt-jira-host .bdd-steps {\n  gap: 6px !important;\n  margin-top: 8px !important;\n}\n\n.rt-scenario-page .bdd-step,\n.rt-jira-host .bdd-step {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  color: var(--text-primary) !important;\n  text-align: left !important;\n  padding: 8px 10px !important;\n  border-radius: 6px;\n}\n\n.rt-scenario-page .bdd-step.given,\n.rt-jira-host .bdd-step.given {\n  border-left: 3px solid #3b82f6 !important;\n}\n\n.rt-scenario-page .bdd-step.when,\n.rt-jira-host .bdd-step.when {\n  border-left: 3px solid #f59e0b !important;\n}\n\n.rt-scenario-page .bdd-step.then,\n.rt-jira-host .bdd-step.then {\n  border-left: 3px solid #22c55e !important;\n}\n\n.rt-scenario-page .analysis-results,\n.rt-jira-host .analysis-results,\n.rt-scenario-page .test-cases-container,\n.rt-jira-host .test-cases-container {\n  background: transparent !important;\n  box-shadow: none !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .analysis-results,\n.rt-jira-host .analysis-results {\n  background: var(--surface) !important;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n}\n\n.rt-scenario-page .parameter-group,\n.rt-jira-host .parameter-group,\n.rt-scenario-page .parameterized-suggestions,\n.rt-jira-host .parameterized-suggestions {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .parameter-values .parameter-value,\n.rt-jira-host .parameter-values .parameter-value,\n.rt-scenario-page .parameter-chip,\n.rt-jira-host .parameter-chip {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .select-all-container label,\n.rt-jira-host .select-all-container label,\n.rt-scenario-page .short-description,\n.rt-jira-host .short-description,\n.rt-scenario-page .preconditions-list,\n.rt-jira-host .preconditions-list {\n  color: var(--text-secondary) !important;\n}\n\n.rt-scenario-page .edit-title-input,\n.rt-scenario-page .edit-description-textarea,\n.rt-scenario-page .edit-expected-result-textarea,\n.rt-scenario-page .edit-precondition-textarea,\n.rt-scenario-page .step-text-textarea,\n.rt-scenario-page .parameter-name-input,\n.rt-scenario-page .parameter-value-input,\n.rt-jira-host .edit-title-input,\n.rt-jira-host .edit-description-textarea,\n.rt-jira-host .edit-expected-result-textarea,\n.rt-jira-host .edit-precondition-textarea,\n.rt-jira-host .step-text-textarea,\n.rt-jira-host .parameter-name-input,\n.rt-jira-host .parameter-value-input {\n  width: 100% !important;\n  max-width: 100% !important;\n  background: var(--input-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--input-border, var(--border)) !important;\n}\n\n.rt-scenario-page .test-case-card.editing-mode,\n.rt-jira-host .test-case-card.editing-mode {\n  background: var(--surface) !important;\n  border-color: var(--primary, #3b82f6) !important;\n}\n\n/* Legacy buttons → token surfaces when not using rt-btn */\n.rt-scenario-page .regenerate-btn,\n.rt-scenario-page .view-tests-btn,\n.rt-scenario-page .generate-tests-btn,\n.rt-jira-host .regenerate-btn,\n.rt-jira-host .view-tests-btn,\n.rt-jira-host .generate-tests-btn {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n}\n\n.rt-scenario-page .generate-tests-btn,\n.rt-jira-host .generate-tests-btn {\n  background: var(--primary, #2563eb) !important;\n  color: #fff !important;\n  border-color: transparent !important;\n}\n\n/* Jira host itself when showing list */\n.rt-jira-host.jira-items-overlay {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  z-index: auto !important;\n  background: var(--bg-primary) !important;\n  min-height: 0;\n  flex: 1;\n}\n\n.rt-jira-host .jira-items-container {\n  background: var(--bg-primary) !important;\n}\n\n.rt-jira-host .jira-items-content,\n.rt-jira-host .jira-items-tabs {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-jira-host table,\n.rt-jira-host th,\n.rt-jira-host td {\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n  background: transparent !important;\n}\n\n.rt-jira-host th {\n  background: var(--table-header, var(--bg-tertiary)) !important;\n  color: var(--text-secondary) !important;\n}\n\n.rt-jira-host .back-btn {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px;\n  padding: 6px 12px;\n}\n\n/* ─── Dark/light token enforcement + kill text-level boxes ─── */\n.rt-scenario-page,\n.rt-scenario-page .ai-testcase-generator-container,\n.rt-scenario-page .rt-scenario-panel,\n.rt-scenario-page .generator-content,\n.rt-scenario-page .rt-scenario-chrome,\n.rt-jira-host .ai-testcase-generator-container,\n.rt-jira-host .generator-content {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .rt-scenario-chrome,\n.rt-jira-host .rt-scenario-chrome,\n.rt-scenario-page .rt-scenario-toolbar,\n.rt-jira-host .rt-scenario-toolbar,\n.rt-scenario-page .test-cases-header,\n.rt-jira-host .test-cases-header {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.rt-scenario-page .test-case-card,\n.rt-jira-host .test-case-card,\n.rt-scenario-page .test-plan-card,\n.rt-jira-host .test-plan-card,\n.rt-scenario-page .test-suite-card,\n.rt-jira-host .test-suite-card,\n.rt-scenario-page .test-case-editor,\n.rt-jira-host .test-case-editor,\n.rt-scenario-page .analysis-results,\n.rt-jira-host .analysis-results,\n.rt-scenario-page .editable-parameter-group,\n.rt-jira-host .editable-parameter-group {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n  box-shadow: none !important;\n}\n\n.rt-scenario-page .expected-result,\n.rt-jira-host .expected-result,\n.rt-scenario-page .bdd-step,\n.rt-jira-host .bdd-step,\n.rt-scenario-page .item-details,\n.rt-jira-host .item-details,\n.rt-scenario-page .collapsed-summary,\n.rt-jira-host .collapsed-summary {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Section titles must sit flat on the card — no boxed labels */\n.rt-scenario-page .test-case-section > h4,\n.rt-jira-host .test-case-section > h4,\n.rt-scenario-page .test-case-section h4,\n.rt-jira-host .test-case-section h4,\n.rt-scenario-page .test-strategy-section h4,\n.rt-jira-host .test-strategy-section h4,\n.rt-scenario-page .test-suites-section h4,\n.rt-jira-host .test-suites-section h4,\n.rt-scenario-page h3,\n.rt-jira-host h3,\n.rt-scenario-page .test-cases-title h3,\n.rt-jira-host .test-cases-title h3 {\n  background: transparent !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  text-shadow: none !important;\n  outline: none !important;\n  color: var(--text-primary) !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.rt-scenario-page .test-case-section p,\n.rt-jira-host .test-case-section p,\n.rt-scenario-page .test-case-section li,\n.rt-jira-host .test-case-section li,\n.rt-scenario-page .preconditions-list li,\n.rt-jira-host .preconditions-list li,\n.rt-scenario-page .short-description,\n.rt-jira-host .short-description,\n.rt-scenario-page .test-case-description,\n.rt-jira-host .test-case-description {\n  background: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n  color: var(--text-secondary) !important;\n}\n\n.rt-scenario-page .generator-header,\n.rt-jira-host .generator-header {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
